import { LOAD_WORK_ORDERS } from "./workOrdersConstants";

export function workOrders(state = [], action) {
    switch (action.type) {
        case LOAD_WORK_ORDERS:
            return action.workOrders;
        default:
            return state;
    }
}
